import { useState, useEffect } from 'react';

function Carousel() {
  const [active, setActive] = useState(0);

  const slides = [
    { img: require('../img/picture_1.png')},
    { img: require('../img/picture_2.png')},
    { img: require('../img/picture_2.png')}
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive(prev => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const getPosIndex = (i) => {
    const total = slides.length;
    return (i - active + total) % total;
    // 0 = front/center, 1 = right, 2 = left
  };

  const positions = [
    { // center — front
      left: '50%',
      translateX: '-50%',
      scale: 1,
      zIndex: 3,
      opacity: 1,
    },
    { // right — behind
      left: '75%',
      translateX: '-30%',
      scale: 0.88,
      zIndex: 2,
      opacity: 0.85,
    },
    { // left — behind
      left: '25%',
      translateX: '-70%',
      scale: 0.88,
      zIndex: 2,
      opacity: 0.85,
    },
  ];

  const mobilePositions = [
    { // center — front
      left: '50%',
      translateX: '-50%',
      scale: 1,
      zIndex: 3,
      opacity: 1,
    },
    { // right — behind
      left: '60%',
      translateX: '-40%',
      scale: 0.88,
      zIndex: 2,
      opacity: 0.85,
    },
    { // left — behind
      left: '40%',
      translateX: '-60%',
      scale: 0.88,
      zIndex: 2,
      opacity: 0.85,
    },
  ];

  return (
    <div className='CarouselSection'>
      <div className='CarouselStack MobileHidden'>
        {slides.map((slide, i) => {
          const pos = positions[getPosIndex(i)];
          return (
            <div
              key={i}
              className='CarouselCard'
              style={{
                left: pos.left,
                zIndex: pos.zIndex,
                opacity: pos.opacity,
                transform: `translateX(${pos.translateX}) scale(${pos.scale})`,
              }}
            >
              <img src={slide.img} className='CarouselImg' />
            </div>
          );
        })}
      </div>
      
      <div className='CarouselStack MobileOnly'>
        {slides.map((slide, i) => {
          const pos = mobilePositions[getPosIndex(i)];
          return (
            <div
              key={i}
              className='CarouselCard'
              style={{
                left: pos.left,
                zIndex: pos.zIndex,
                opacity: pos.opacity,
                transform: `translateX(${pos.translateX}) scale(${pos.scale})`,
              }}
            >
              <img src={slide.img} className='CarouselImg' />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Carousel;